import { useState } from 'react'
import { useRequests } from '../requests/useRequests'

export const useNewConversation = () => {
  const requests = useRequests()
  const [loading, setLoading] = useState<boolean>(false)
  const [error, setError] = useState<string | null>(null)

  const createNewConversation = async (recipientIdentifier: string, message: string) => {
    if (!recipientIdentifier.trim() || !message.trim()) return null

    setLoading(true)
    setError(null)

    try {
      // Wyszukaj użytkownika po nazwie użytkownika/emailu/identyfikatorze
      let recipientId
      let recipientData

      // Sprawdź, czy recipientIdentifier to liczba (ID)
      if (/^\d+$/.test(recipientIdentifier)) {
        recipientId = parseInt(recipientIdentifier, 10)
      } else {
        // Wyszukaj użytkownika po nazwie użytkownika lub emailu
        const searchResponse = await requests.searchUsers(recipientIdentifier)
        const users = searchResponse.data

        if (users.length === 0) {
          throw new Error('Nie znaleziono użytkownika o podanej nazwie lub adresie email')
        }

        // Wybierz pierwszego pasującego użytkownika
        recipientData = users[0]
        recipientId = recipientData.id
      }

      if (!recipientId) {
        throw new Error('Nie udało się zidentyfikować odbiorcy')
      }

      // Utwórz konwersację
      const convResponse = await requests.getOrCreateConversation(recipientId)
      const conversationId = convResponse.data.id

      // Wyślij wiadomość
      await requests.sendMessage({
        content: message,
        recipientId,
        conversationId
      })

      return conversationId
    } catch (err) {
      setError('Nie udało się utworzyć konwersacji. ' +
        (err instanceof Error ? err.message : 'Spróbuj podać dokładny login, email lub ID użytkownika.'))
      return null
    } finally {
      setLoading(false)
    }
  }

  return { createNewConversation, loading, error }
}
